var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.31 77.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin {\n        fill: #dcba8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M73.68,65.88A14,14,0,0,1,100.38,60c5.64-6.11,8.93-13.4,8.93-21.23C109.31,17.36,84.84,0,54.65,0S0,17.36,0,38.79c0,7.26,2.82,14.05,7.71,19.86A14,14,0,1,1,31.2,73.82a73.52,73.52,0,0,0,23.45,3.75,74,74,0,0,0,21.89-3.24A13.89,13.89,0,0,1,73.68,65.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset41);
export default __webpack_public_path__ + "static/media/Asset 41.ebe847e8.svg";
export { ForwardRef as ReactComponent };